module.exports = __webpack_public_path__ + "img/cfc-02.5b4698c1.png";